module.exports = __webpack_public_path__ + "img/phone_icon.8761214e.png";